export enum VideoTypeEnum {
  Student = 1,
  Trainer = 2,
}
